import React from 'react';
import { clsx } from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import deskIcon from '../assets/images/sidebar/desk_icon.png';
import analysisIcon from '../assets/images/common/search-calendar-icon.png';
import settingIcon from '../assets/images/sidebar/settings_icon.png';

interface NavItem {
    labelKey: string;
    icon: string;
    href: string;
}

const navItems: NavItem[] = [
    { labelKey: 'nav.settings', icon: settingIcon, href: '/settings' },
    { labelKey: 'nav.analysis', icon: analysisIcon, href: '/analysis' },
    { labelKey: 'nav.desk', icon: deskIcon, href: '/desk' },
];

/**
 * モバイル用ボトムナビゲーション
 * @returns
 */
const BottomNav: React.FC = () => {
    /**
     * データ取得
     */

    const { pathname } = useLocation();
    const { t } = useTranslation('sidebar');

    // レンダリング
    return (
        <>
            <nav id="bottom-nav" className="h-24 fixed bottom-0 left-0 w-full bg-kotomilThemaColor shadow-lg z-10 px-4 bg-opacity-95 rounded-t-xl">
                <div className="flex items-center justify-center gap-8">
                    {navItems.map(({ labelKey, icon: Icon, href }) => (
                        <Link
                            key={href}
                            id={href === '/desk' ? 'bottom-nav-desk' : href === '/analysis' ? 'bottom-nav-analysis' : undefined}
                            to={href}
                            className={clsx(
                                'w-3/12 h-20 group flex flex-col rounded-xl items-center gap-1 px-4 py-4 font-medium hover:bg-white/30 transition',
                                pathname === href && 'bg-white/40',
                            )}
                        >
                            <img src={Icon} className="size-8" />
                            <span className="text-sm font-bold">{t(labelKey)}</span>
                        </Link>
                    ))}
                </div>
            </nav>
        </>
    );
};

export default BottomNav;
